import { useId } from "react";

/** Logo PROXIreduc-28 — version professionnelle épurée (orange / noir), + déclinaison blanche.
 *  variant: "color" (défaut) pour fonds clairs, "white" pour fonds sombres (pied de page, bandeaux noirs).
 *  Props : className, showTagline, variant. */
export const BrandLogoFull = ({ className = "", showTagline = true, variant = "color", ...props }) => {
  const g = useId();
  const white = variant === "white";
  const pct = white ? "rgba(15,15,17,0.45)" : "#E05638";
  const tInk = white ? "#FFFFFF" : "#0F0F11";
  const tAccent = white ? "#FFFFFF" : "#E05638";
  return (
    <svg viewBox={`0 0 1180 ${showTagline ? 360 : 300}`} className={className} role="img"
         aria-label="PROXIreduc-28 — Vos avantages près de chez vous" {...props}>
      <defs>
        <linearGradient id={g} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#F2762A" /><stop offset="1" stopColor="#E05638" />
        </linearGradient>
      </defs>

      {/* ===== Marque : pin de localisation + pourcentage ===== */}
      <g transform="translate(24,28)">
        <path d="M118,248 C118,248 34,176 34,116 C34,64 72,26 118,26 C164,26 202,64 202,116 C202,176 118,248 118,248 Z"
              fill={white ? "#FFFFFF" : `url(#${g})`} />
        {!white && <circle cx="118" cy="112" r="52" fill="#FFFFFF" />}
        <line x1="98" y1="139" x2="138" y2="85" stroke={pct} strokeWidth="11" strokeLinecap="round" />
        <circle cx="101" cy="97" r="9" fill={pct} />
        <circle cx="135" cy="127" r="9" fill={pct} />
      </g>

      {/* ===== Logotype ===== */}
      <text x="276" y="204" fontFamily="'Outfit',system-ui,sans-serif" fontWeight="800" fontSize="116" letterSpacing="-3">
        <tspan fill={tInk}>PROXI</tspan><tspan fill={tAccent}>reduc</tspan><tspan fill={tInk}>-28</tspan>
      </text>

      {showTagline && (
        <text x="280" y="296" fontFamily="'Outfit',system-ui,sans-serif" fontWeight="600" fontSize="42" letterSpacing="0.5"
              fill={white ? "#FFFFFF" : "#71717A"} fillOpacity={white ? 0.8 : 1}>
          Vos avantages près de chez vous
        </text>
      )}
    </svg>
  );
};

export default BrandLogoFull;
